module.exports = __webpack_public_path__ + "img/marianne-profile-image.1ee1a297.webp";